import React, { createContext, useEffect } from 'react';
import { notification } from 'antd';
import type { NotificationInstance } from 'antd/es/notification/interface';
import type { NotifyParams } from '@shared/hooks/use-notify';

export const NotificationContext = createContext<NotificationInstance | null>(null);

export let notify: (params: NotifyParams) => void = () => {
  console.warn('Notification not initialized');
};

export const NotificationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [api, contextHolder] = notification.useNotification();

  useEffect(() => {
    notify = ({ type = 'error', ...rest }: NotifyParams) => {
      api[type]({
        duration: 3,
        placement: 'bottomRight',
        pauseOnHover: true,
        showProgress: true,
        ...rest,
      });
    };
  }, [api]);

  return (
    <NotificationContext.Provider value={api}>
      {contextHolder}
      {children}
    </NotificationContext.Provider>
  );
};
